export default "__VITE_ASSET__CA1qtYjr__"